module.exports = __webpack_public_path__ + "static/img/sb_promo.5f36229.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blast/sb_promo.jpg
// module id = 8ejF
// module chunks = 1